import { CategoryButtonTitle, TViewSwitcherKey } from '@models/home';
import { createSlice } from '@reduxjs/toolkit';

interface IDashboardBackgroundImgSliceState {
  category: CategoryButtonTitle;
  view: TViewSwitcherKey;
}

const initialState: IDashboardBackgroundImgSliceState = {
  category: null,
  view: 'immediate',
};

const dashboardBackgroundImgSlice = createSlice({
  name: 'dashboardBackgroundImgSlice',
  initialState,
  reducers: {
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setView: (state, action) => {
      state.view = action.payload;
    },
  },
});

export const { setCategory, setView } = dashboardBackgroundImgSlice.actions;
export default dashboardBackgroundImgSlice.reducer;
